import { render, staticRenderFns } from "./EditBeneficiaryModal.vue?vue&type=template&id=57ea334f&"
import script from "./EditBeneficiaryModal.vue?vue&type=script&lang=js&"
export * from "./EditBeneficiaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports